<template>
    <div class="animated fadeIn">
        <b-card no-body>
            <b-card-body fluid="xl">
                <b-card-title class="text-center mb-2">
                    <h2>Visitor Entry</h2>
                </b-card-title>
                <b-form @submit.stop.prevent="onSubmit">
                    <b-row>
                        <b-col>
                            <b-form-group label="" label-for="issatsangi">
                                <b-form-checkbox size="lg" v-model="$v.form.issatsangi.$model"
                                    @change="toggleBuildingHouses" id="issatsangi" name="issatsangi"
                                    :state="validateState('issatsangi')" switch>
                                    <b>Is Visitor Satsangi? </b>
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-if="!showHouses">
                            <b-form-group label-class="font-weight-bold" label="Satsangi Id Number"
                                label-for="idNumber">
                                <b-form-input id="idNumber" :state="validateState('idNumber')" name="idNumber"
                                    v-model.lazy.trim="$v.form.idNumber.$model" autofocus
                                    @keydown.native="handleEnterKey" @blur="handleEnterKey" />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Adhar Card Number" label-for="adharid">
                                <b-form-input id="adharid" name="adharid" :state="validateState('adharid')"
                                    v-model="$v.form.adharid.$model" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Name" label-for="visitorname">
                                <b-form-input id="visitorname" name="visitorname" :state="validateState('visitorname')"
                                    aria-describedby="liveFeedbackVisitorname" v-model="$v.form.visitorname.$model" />
                                <b-form-invalid-feedback id="liveFeedbackVisitorname">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Mobile Number" label-for="mobileNumber">
                                <b-form-input id="mobileNumber" name="mobileNumber"
                                    aria-describedby="liveFeedbackMobileNumber" :state="validateState('mobileNumber')"
                                    maxlength="12" v-model="$v.form.mobileNumber.$model" />
                                <b-form-invalid-feedback id="liveFeedbackMobileNumber">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="!showHouses">
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Building Name" label-for="buildingName">
                                <b-form-select :options="buildings" v-model="$v.form.buildingName.$model"
                                    :state="validateState('buildingName')" value-field="id" text-field="name" >                                    
                                    </b-form-select>
                                <b-form-invalid-feedback id="liveFeedbackbuildingName">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="showHouses">
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Visiting House" label-for="houseNo">
                                <b-form-select :options="houses" v-model="$v.form.houseNo.$model"
                                    :state="validateState('houseNo')" value-field="houseno" text-field="name" />
                                <b-form-invalid-feedback id="liveFeedbackhouseNo">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Arrival Date" label-for="fromdate">
                                <b-form-datepicker id="fromdate" name="fromdate" :min="form.todate ? form.todate : min"
                                    :initial-date="min" :state="validateState('fromdate')"
                                    v-model.trim="$v.form.fromdate.$model" aria-describedby="liveFeedbackFromDate"
                                    placeholder="DD/MM/YYYY" today-button reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />

                            </b-form-group>
                            <b-form-invalid-feedback id="liveFeedbackFromDate">Please enter From
                                Date</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Departure Date" label-for="todate">
                                <b-form-datepicker id="todate" name="todate" :min="form.fromdate ? form.fromdate : min"
                                    :state="validateState('fromdate')" v-model.trim="$v.form.todate.$model"
                                    aria-describedby="liveFeedbackToDate" placeholder="DD/MM/YYYY" today-button
                                    reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />

                            </b-form-group>
                            <b-form-invalid-feedback id="liveFeedbackTiDate">Please enter To
                                Date</b-form-invalid-feedback>
                        </b-col>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Departure Time" label-for="toTime">
                                <b-input-group class="mb-3">
                                    <b-form-input id="toTime-input" v-model="$v.form.toTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="toTime" name="toTime" v-model="$v.form.toTime.$model"
                                            button-only right locale="en" :state="validateState('toTime')"
                                            aria-describedby="liveFeedbackToTime" now-button reset-button
                                            aria-controls="toTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackToTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>


                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="No of People" label-for="people">
                                <b-form-spinbutton id="people" v-model="$v.form.$model.people" min=0 max=10000
                                    inline></b-form-spinbutton>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
                                Save
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button class="ml-1" type="reset" @click="onReset">Reset</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
    mapState,
    mapActions
} from 'vuex'

import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength, numeric, minValue, maxLength, email, alpha, helpers } from "vuelidate/lib/validators";

const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
const formShape = {
    idNumber: null,
    adharid: null,
    visitorname: null,
    mobileNumber: null,
    buildingName: null,
    fromdate: null,
    todate: null,
    toTime: null,
    people: 1,
    houseNo: null,
    issatsangi: true

}
export default {
    mixins: [validationMixin],
    name: "VistorEntry",
    data() {
        return {
            form: Object.assign({}, formShape),
            min: new Date(),
            submitted: false,
            showHouses: false,
        }
    },
    computed: mapState({
        buildings: state => state.buildings.allBuildings,
        houses: state => state.buildings.allHouses,
    }),
    validations: {
        form: {
            idNumber: {
                required: requiredIf(function (nestedModel) {
                    return this.form.adharid == null || this.form.adharid.length == 0
                })
            },
            adharid: {
                required: requiredIf(function (nestedModel) {
                    return this.form.idNumber == null || this.form.idNumber.length == 0
                })
            },
            visitorname: {},
            mobileNumber: {},
            buildingName: {
                required: requiredIf(function (nestedModel) {
                    return this.form.houseNo == null || this.form.houseNo.length == 0
                })
            },
            fromdate: { required },
            todate: { required },
            toTime: { required },
            people: { required },
            issatsangi: { required },
            houseNo: {
                required: requiredIf(function (nestedModel) {
                    return this.form.buildingName == null || this.form.buildingName.length == 0
                })
            }

        }
    },
    methods: {
        toggleBuildingHouses() {
            this.showHouses = !this.showHouses;
            this.form.buildingName = null;
            this.form.houseNo = null;
        },
        handleEnterKey(event) {
            if ((event.which == 13 || event.type == 'blur') && this.form.idNumber != null && this.form.idNumber.length > 0) {
                let params = { id_card_no: this.form.idNumber };
                Vue.axios.post("/validateSatsangi", params)
                    .then(response => {
                        console.log(response);
                        if (typeof response.data !== "undefined" && response.data.success == true && response.data.customer != null) {
                            let item = _.clone(response.data.customer[0]);
                            this.form.visitorname = item.main_name + ' ' + item.surname;
                            this.form.mobileNumber = item.phone;
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.error });
                            }
                            else {
                                this.showErrorMsg({ message: "Satsangi Not foud with entered Satsangi Id Number. Please enter data manually." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.error
                            });
                        } else {
                            this.showErrorMsg();
                        }
                    })
            }

        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        onReset() {
            // Reset validation
            this.form = Object.assign({}, formShape);           
            this.submitted = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.form.fromdate = this.formatDate(new Date())
        },
        onSubmit() {
            if (this.submitted == false) {
                let returnValue = this.compareDates(this.form.fromdate, this.form.todate);
                console.log(returnValue);
                if (returnValue == false) {
                    this.showErrorMsg({
                        message: "Departure date must be after the arrival date"
                    })
                    return;
                }
                this.submitted = true;
                let params = {
                    id_card_no: this.form.idNumber,
                    adharid: this.form.adharid,
                    visitorname: this.form.visitorname,
                    mobileNumber: this.form.mobileNumber,
                    buildingName: this.form.buildingName,
                    fromdate: this.form.fromdate,
                    todate: this.form.todate,
                    departure_time: this.form.toTime,
                    people: this.form.people,
                    houseNo: this.form.houseNo,
                    issatsangi: this.form.issatsangi

                };
                Vue.axios.post("/admin/createEntry", params)
                    .then(response => {
                        console.log(response);
                        if (response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        }
                        else if (typeof response.data !== "undefined" && response.data.success == true) {
                            this.showSuccessMsg({ message: "Entry created successfully." });
                            this.onReset()
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.message });
                              
                            }
                            else {
                                this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        } else {
                            this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                        }
                    })
                console.log(this.form);
                this.submitted = false;
            }
        }
    },
    beforeMount() {
        this.$store.dispatch('buildings/getAllBuildings')
        this.$store.dispatch('buildings/getAllHouses')
    },
    created() {
        this.form.fromdate = this.formatDate(new Date())
    }


}
</script>